<script setup>
import { useI18n } from 'vue-i18n';
import { useCustomerStore } from '@client/js/store/customer';
import { vMaska } from "maska/vue";
import ErrorNote from '@client/js/components/ErrorNote.vue';
const customerStore = useCustomerStore();
const { t } = useI18n();

</script>
<template>
    <div>
        <div class="text-field">
            <input name="firstName" type="text" placeholder="" v-model="customerStore.firstName"
                v-bind="customerStore.firstNameProps" />
            <label class="fieldLabel" for="firstName">{{ t('fields.firstName') }}</label>
            <ErrorNote :message="customerStore.errors.firstName" />
        </div>
        <div class="text-field">
            <input name="lastName" type="text" placeholder="" v-model="customerStore.lastName"
                v-bind="customerStore.lastNameProps" />
            <label class="fieldLabel" for="lastName">{{ t('fields.lastName') }}</label>
            <ErrorNote :message="customerStore.errors.lastName" />
        </div>
        <div class="text-field">
            <input name="phoneNumber" type="text" maxlength="20" v-maska inputmode="numeric"
                data-maska="+1 (###) ###-####" placeholder="" v-model="customerStore.phoneNumber"
                v-bind="customerStore.phoneNumberProps" />
            <label class="fieldLabel" for="phoneNumber">{{ t('fields.mobilePhone') }}</label>
            <ErrorNote :message="customerStore.errors.phoneNumber" />
        </div>
        <div class="text-field">
            <input name="email" type="text" placeholder="" v-model="customerStore.email"
                v-bind="customerStore.emailProps" />
            <label class="fieldLabel" for="email">{{ t('fields.emailAddress') }}</label>
            <ErrorNote :message="customerStore.errors.email" />
        </div>
    </div>
</template>